import { equals } from 'ramda';
import {
    getEmailInSidebar,
    getFirstNameInSidebar,
    getLastNameInSidebar,
    getPersistedEmailInSidebar,
    getPhoneNumberInSidebar,
    getPersistedFirstNameInSidebar,
    getPersistedGroupIdsInSidebar,
    getPersistedLastNameInSidebar,
    getPersistedPhoneNumberInSidebar,
    getUserGroupsInSidebar,
} from './userSidebarSelectors';
import type { RootState } from '../../../../configuration/setup/store';

export const userSidebarHasChanges = (state: RootState) => {
    const newGroups = getUserGroupsInSidebar(state);
    const emailChanges = (getEmailInSidebar(state) ?? '') !== (getPersistedEmailInSidebar(state) ?? '');
    const phoneNumberChanges =
        (getPhoneNumberInSidebar(state) ?? '') !== (getPersistedPhoneNumberInSidebar(state) ?? '');

    const lastNameChanges = getLastNameInSidebar(state) !== getPersistedLastNameInSidebar(state);
    const firstNameChanges = getFirstNameInSidebar(state) !== getPersistedFirstNameInSidebar(state);

    const groupChanges = newGroups !== undefined && !equals(getPersistedGroupIdsInSidebar(state), newGroups);

    const fieldChanges = emailChanges || phoneNumberChanges || firstNameChanges || lastNameChanges;
    return groupChanges || fieldChanges;
};
